const state = {
  image: null
};

const getters = {
  getPreview2D: state => {
    return state.image;
  }
};

const mutations = {
  setPreview2D: (state, payload) => {
    state.image = payload;
  }
};

const actions = {
  setPreview2D: ({ commit }, payload) => {
    commit("setPreview2D", payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
